import { Component, Input } from '@angular/core';
import { SocialLoginService } from '../../Services/social-login.service';


@Component({
  selector: 'app-typing-component',
  standalone: false,
  templateUrl: './typing-component.component.html',
  styleUrl: './typing-component.component.css'
})
export class TypingComponentComponent {
  @Input() textToType: string = "";
  typedText: string = "";
  showText: boolean = true;
  typingSpeed: number = 100; 
  eraseSpeed: number = 50;
  delayBeforeErase: number = 1500; 
  index: number = 0;
  isErasing: boolean = false;
  platform:string=''
  constructor(private authsocial:SocialLoginService){
     this.authsocial.Getplarform().then(x=>{
      this.platform=x
     })
  }

  ngOnInit() {
    this.authsocial.Getplarform().then(x=>{
      this.platform=x
     })
    this.startTyping();
  }

  startTyping() {
    if (!this.isErasing) {
      if (this.index < this.textToType.length) {
        this.typedText += this.textToType[this.index];
        this.index++;
        setTimeout(() => this.startTyping(), this.typingSpeed);
      } else {
        // Wait before erasing
        setTimeout(() => {
          this.isErasing = true;
          this.startErasing();
        }, this.delayBeforeErase);
      }
    }
  }

  startErasing() {
    if (this.isErasing) {
      if (this.typedText.length > 0) {
        this.typedText = this.typedText.slice(0, -1);
        setTimeout(() => this.startErasing(), this.eraseSpeed);
      } else {
        // Restart typing after erasing
        this.isErasing = false;
        this.index = 0;
        setTimeout(() => this.startTyping(), this.typingSpeed);
      }
    }
  }
}
